module.exports = __webpack_public_path__ + "img/限时商品4.14a92e5e.png";